export default __webpack_public_path__ + "static/media/4.1ca5c4e7.png";